
import { defineComponent, watch } from "vue";
import { disableBodyOverflow, enableBodyOverflow } from "../../../mixins";

export default defineComponent({
  name: "LogoutConfirm",
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    watch(
      () => props.isOpen,
      newVal => {
        if (newVal) {
          disableBodyOverflow();
        } else {
          enableBodyOverflow();
        }
      },
      { immediate: true }
    );
  }
});
